import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  Input,
} from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StoreService } from '@shared/services/store.service';

@Component({
  selector: 'side-panel',
  templateUrl: 'side-panel.component.html',
  styleUrls: ['side-panel.component.scss'],
  imports: [FormsModule, ReactiveFormsModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SidePanelComponent {
  @Input() title = 'Header';
  @Input() secondaryButtonLabel?: string;
  @Input() primaryButtonLabel?: string;
  @Input() onSecondaryButtonClick = (event: Event) => {};
  @Input() onPrimaryButtonClick = (event: Event) => {};
  @Input() extraCssClasses = '';
  @Input() withFooter = true;
  @Input() primaryButtonDisabled = false;
  @Input() nopadding = false;
  @Input() closeOnPrimaryAction = true;
  storeService = inject(StoreService);
}
